/// <reference path="../nativewind-augmentation.d.ts" />
// Copyright (c) Ping. All rights reserved.
//
// RN + NativeWind mirror of `apps/web/src/shell/hosts/
// ContactsRouteHost.tsx`'s 2-column composition. The host wires
// `useContactsBundle` + the selected-user lookup and passes them
// down via props; this component owns the layout (list on the left,
// detail / empty-state on the right) and forwards add-contact +
// selection events back up.
//
// Conversion notes:
//   - `<div className="flex flex-row w-full h-screen min-h-0">` ->
//     `<View>` with the same classes.
//   - Modal hoisting: the web host mounts `<NewChatModal>` as a
//     sibling so it overlays the entire route. We keep that on the
//     host (web + desktop both already mount `NewChatModal` at the
//     shell root) — `onAddContact` here just signals upward.

import { View } from "react-native";
import { ContactDetailView } from "./ContactDetailView";
import { ContactsEmptyState } from "./ContactsEmptyState";
import { ContactsListPanel } from "./ContactsListPanel";
import type { ContactsScreenProps } from "./ContactsScreen.types";

export function ContactsScreen(props: ContactsScreenProps): JSX.Element {
	const {
		bundle,
		isLoading,
		selectedUserId,
		selectedUser,
		isSelectedUserLoading,
		onUserSelect,
		onAddContact,
		onImportContacts,
		onMessageRequested,
		onAudioCall,
		onVideoCall,
		onRemoveContact,
		onMorePress,
		onCreateFolder,
		onToggleFavourite,
	} = props;

	const isFavourite =
		selectedUserId !== null && bundle.favouriteIds.includes(selectedUserId);

	return (
		<View className="flex flex-row w-full h-screen min-h-0">
			<ContactsListPanel
				bundle={bundle}
				isLoading={isLoading}
				selectedUserId={selectedUserId}
				onUserSelect={onUserSelect}
				onAddContact={onAddContact}
				{...(onImportContacts !== undefined ? { onImportContacts } : {})}
				{...(onCreateFolder !== undefined ? { onCreateFolder } : {})}
			/>
			<View className="flex-1 min-w-0 min-h-0 flex flex-col">
				{selectedUserId !== null ? (
					<ContactDetailView
						user={selectedUser}
						isLoading={isSelectedUserLoading}
						onMessageRequested={onMessageRequested}
						isFavourite={isFavourite}
						{...(onAudioCall !== undefined ? { onAudioCall } : {})}
						{...(onVideoCall !== undefined ? { onVideoCall } : {})}
						{...(onRemoveContact !== undefined ? { onRemoveContact } : {})}
						{...(onMorePress !== undefined ? { onMorePress } : {})}
						{...(onToggleFavourite !== undefined ? { onToggleFavourite } : {})}
					/>
				) : (
					<ContactsEmptyState onAddContact={onAddContact} />
				)}
			</View>
		</View>
	);
}
